import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import UrgencyBar from '../components/sections/UrgencyBar';
import EventSection from '../components/sections/EventSection';
import TraditionSection from '../components/sections/TraditionSection';
import VenueSection from '../components/sections/VenueSection';
import ChefAtelierSection from '../components/sections/ChefAtelierSection';
import RSVPSection from '../components/sections/RSVPSection';

export default function GaletteDesRois() {
  return (
    <>
      <Navbar />
      <Hero />
      <UrgencyBar />
      <EventSection />
      <TraditionSection />
      <VenueSection />
      <ChefAtelierSection />
      <RSVPSection />
      <Footer />
    </>
  );
}